import { Controller } from "@hotwired/stimulus"

// AI poem generator component: keeps the creativity slider's live label in
// sync, populates the form from a table row's "Reuse" button, and clears
// the generated-poem preview on "Discard" (no server round-trip needed).
export default class extends Controller {
  static targets = [
    "temperatureInput", "temperatureValue",
    "styleSelect", "modelSelect", "languageSelect", "promptInput",
    "responseFrame", "submitButton", "submitSpinner", "submitLabel"
  ]

  updateTemperatureLabel() {
    this.temperatureValueTarget.textContent = Number(this.temperatureInputTarget.value).toFixed(1)
  }

  // Turbo Frame form submission (generating a poem) can take a while, since
  // it waits on the LLM response - disable the button and swap in a spinner
  // so it's clear the request is still running.
  showSpinner() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true
    if (this.hasSubmitSpinnerTarget) this.submitSpinnerTarget.classList.remove("d-none")
    if (this.hasSubmitLabelTarget) this.submitLabelTarget.textContent = this.submitLabelTarget.dataset.loadingText
  }

  hideSpinner() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = false
    if (this.hasSubmitSpinnerTarget) this.submitSpinnerTarget.classList.add("d-none")
    if (this.hasSubmitLabelTarget) this.submitLabelTarget.textContent = this.submitLabelTarget.dataset.defaultText
  }

  reuse(event) {
    const { style, model, language, prompt, temperature } = event.currentTarget.dataset

    this.styleSelectTarget.value = style
    this.modelSelectTarget.value = model
    this.languageSelectTarget.value = language
    this.promptInputTarget.value = prompt || ""
    if (temperature) {
      this.temperatureInputTarget.value = temperature
      this.updateTemperatureLabel()
    }
    this.styleSelectTarget.closest("form")?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  discard() {
    if (this.hasResponseFrameTarget) this.responseFrameTarget.innerHTML = ""
  }
}
